'use strict';

import { render, unmountComponentAtNode } from 'react-dom';
import PjaxWrapper from '../utils/PjaxWrapper';
import SocialShareBar from '../components/SocialShareBar/SocialShareBar';

/**
 *
 * @param {string} containerId
 * @param {array} shownTabs         -> Usage: see ModelSocialShareBarOptions
 * @param {array} shownShareButtons -> Usage: see ModelSocialShareBarOptions
 * @param {string} mediaId
 * @param {string} url              -> URL to Share via SocialMedia
 * @param {string} title
 * @param {bool} loggedIn
 * @param {int} guestId
 * @param {string} embedBaseUrl
 * @param {string} gaPrefix
 */
function run(containerId, shownTabs, shownShareButtons, mediaId, url, title, loggedIn, guestId, embedBaseUrl, gaPrefix) {
	const container = document.getElementById(containerId);

	render(
		<SocialShareBar
			shownTabs={shownTabs}
			shownShareButtons={shownShareButtons}
			mediaId={mediaId}
			url={url}
			title={title}
			loggedIn={loggedIn}
			guestId={guestId}
			embedBaseUrl={embedBaseUrl}
			gaPrefix={gaPrefix}
		/>,
		container,
	);

	PjaxWrapper.addUnloadFunc(() => {
		unmountComponentAtNode(container);
	});
}

export { run };
